module.exports = __webpack_public_path__ + "static/media/sn.9fdc0f23.png";